import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import LeaveForm from "../../Leave/LeaveForm";

const LeaveApply = () => {
  const { t } = useTranslation();
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const updateState = () => {
    setUpdate(!update);
  };

  return (
    <div>
      <div className="container pt-4">
        <h4 className="text-brand">
          <Link to="/leave">
            <i
              className="fas fa-arrow-left link"
              style={{ cursor: "pointer" }}
            />
          </Link>
          &nbsp;&nbsp;{t("Apply for Leave")}
        </h4>
        <div className="accordion my-3 bg-white" id="accordionFAQs">
          <React.Fragment>
            <LeaveForm updateState={updateState} />
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

export default LeaveApply;
